import { cn } from "../lib/cn";

export interface BrianSlipProps {
  understood: string;
  changed: string[];
  pending: string[];
  needsReview: string[];
  className?: string;
}

function SlipRow({ label, lines }: { label: string; lines: string[] }) {
  if (lines.length === 0) return null;
  return (
    <div className="grid grid-cols-[6.5rem_minmax(0,1fr)] gap-x-3 py-2">
      <dt className="text-mono-caps text-xs text-annotation">{label}</dt>
      <dd className="flex flex-col gap-0.5 text-sm text-ink-body">
        {lines.map((line) => (
          <span key={line}>{line}</span>
        ))}
      </dd>
    </div>
  );
}

export function BrianSlip({
  understood,
  changed,
  pending,
  needsReview,
  className,
}: BrianSlipProps) {
  return (
    <dl className={cn("divide-y divide-rule", className)}>
      <SlipRow label="Understood" lines={understood ? [understood] : []} />
      <SlipRow label="Changed" lines={changed} />
      <SlipRow label="Pending" lines={pending} />
      <SlipRow label="Needs review" lines={needsReview} />
    </dl>
  );
}
